export default "__VITE_ASSET__BH_LpXZ___"